module.exports = __webpack_public_path__ + "static/privacy-policy-dba4ebdb2ee6e79cc65e70aa22173db2.jpg";